import styled from 'styled-components'
import tw from 'twin.macro'

export const TextAndIconContainer = styled.div`
  ${tw`flex items-center	`};
  ${(props) => props.css}
`

export const IconWrapper = styled.div`
  ${tw`mr-2`};
  ${(props) => props.css}
`
